/**
 * @author: Codex
 * @date: 2026/05/07
 * @desc: CasualGamesHub/ArrowsTopCharts页面
 */
import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import ReusePageTemplate from '@intelligence/v3/components/ReusePageTemplate';
import ActiveUsers from '@intelligence/v3/pages/TopCharts/MobileGames/ActiveUsers';

interface IArrowsTopChartsProps extends IBaseProps {}

const ArrowsTopCharts: React.FC<IArrowsTopChartsProps> = (props) => {
  const { style, className } = props;

  const { formatMessage } = useIntl();

  return (
    <ReusePageTemplate
      style={style}
      className={classnames('dbi-reuse-page-arrows-top-charts', className)}
      title={formatMessage({ id: 'dbi_reuse_page_title_arrows_top_charts' })}
      subTitle={formatMessage({ id: 'dbi_reuse_page_sub_title_arrows_top_charts' })}
    >
      <ActiveUsers
        pageLogConfigKey="casualGamesHubArrowsTopCharts"
        downloadLogConfigKey="casualGamesHubArrowsTopChartsDownloadClick"
      />
    </ReusePageTemplate>
  );
};

export default ArrowsTopCharts;
